<script>
export default {
	name: 'FishIcon',
}
</script>

<template>
	<svg
		class="fish-icon"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path
			d="M4.33203 8C4.9587 5.69333 7.62536 4 9.9987 4C12.372 4 14.0387 5.69333 14.6654 8C14.0387 10.3133 12.372 12 9.9987 12C7.62536 12 4.9587 10.3133 4.33203 8Z"
			stroke="currentColor"
			stroke-width="1.66667"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12 8V8.33333"
			stroke="currentColor"
			stroke-width="1.66667"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.6651 11.9533C9.79791 10.8178 9.32813 9.42871 9.32812 7.99996C9.32813 6.57122 9.79791 5.1821 10.6651 4.04663"
			stroke="currentColor"
			stroke-width="1.66667"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M4.666 7.11341C4.666 5.33341 3.71934 3.98008 1.81934 3.66675C1.15267 4.66675 1.15267 7.00008 1.97267 8.00008C1.146 9.00008 1.146 11.3334 1.81934 12.3334C3.71934 12.0201 4.666 10.6667 4.666 8.88675"
			stroke="currentColor"
			stroke-width="1.66667"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M6.97203 4.84001C6.7987 3.92001 6.11203 2.82668 5.33203 2.00001H9.1987C9.51503 1.99884 9.82147 2.11017 10.0633 2.31412C10.3051 2.51807 10.4665 2.80135 10.5187 3.11334L10.672 4.04668"
			stroke="currentColor"
			stroke-width="1.66667"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.672 11.9533L10.5187 12.8867C10.4665 13.1987 10.3051 13.482 10.0633 13.6859C9.82147 13.8899 9.51503 14.0012 9.1987 14H6.33203C6.97793 13.2677 7.33154 12.3231 7.32536 11.3467"
			stroke="currentColor"
			stroke-width="1.66667"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<style scoped>
.fish-icon {
	width: 100%;
	height: 100%;
	display: block;
}
</style>
